// extracted by mini-css-extract-plugin
export default {"title__Item__Wrap":"styles_title__Item__Wrap__+0o+Q","dash__Wrap":"styles_dash__Wrap__YK3Kv","lead__dash":"styles_lead__dash__F3Ca0","trail__dash":"styles_trail__dash__POhso"};